<template>
  <div
    :class="['ai_box', (this.$root.$data.miniprogram || this.$root.$data.isApp) ? 'ai_box_top' : '']"
  >
    <common-title titleName="题库ai助手" :isAPPShow="false" :bcColor="'#f7f8fc'"></common-title>
    <div class="lists_area" ref="van_scroll_ref">
      <!-- <van-pull-refresh v-model="refreshing" @refresh="onRefresh" ref="van_scroll_ref"> -->
      <van-list
        v-model="loading"
        :finished="finished"
        :immediate-check="false"
        :offset="20"
        @load="onLoad"
        direction="up"
      >
        <!-- direction="up" -->
        <!-- 历史消息 -->
        <div id="AILISTITEM" class="history_item" v-for="item in historyList" :key="item">
          <div v-if="toolRawTime(item.createTime) && item.roleType === 1" class="msg_time_box">
            <div class="msg_time">{{toolRawTime(item.createTime)}}</div>
          </div>
          <div class="my_msg_box" v-if="item.roleType === 1">
            <div class="my_msg my_msg_history">
              <div class="msg_text">{{item.content}}</div>
            </div>
          </div>
          <div class="ai_msg_img" v-if="item.roleType === 2">
            <img
              src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-words-mini/ai/ai_title_img.png"
              alt
            />
            <div class="ai_msg_img_name">启小航</div>
          </div>
          <div class="ai_msg" v-if="item.roleType === 2">
            <div class="msg_text">{{toolFilterSymbol(item.content)}}</div>
          </div>
        </div>
        <!-- 欢迎语位置 -->
        <div id="ai_wecome_click" class="wecome_item" v-if="showWecome">
          <div class="wecome_back">
            <div class="tool_hello">{{toolHello}}</div>
            <div class="tool_desc">{{toolDesc}}</div>
            <!-- <img
              class="img"
              src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-words-mini/ai/ai_card.png"
              alt
            />-->
          </div>
          <div class="wecome_card">
            <div class="wecome_tip">
              <img
                class="img_wenhao"
                src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-words-mini/ai/wenhao.png"
                alt
              />
              <div class="tip_wen">你可以试着问我：</div>

              <div class="tip_qiehuan" @click="onSwapHello">换一批</div>

              <img
                class="img_qiehuan"
                src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-words-mini/ai/qiehuan.png"
                alt
                @click="onSwapHello"
              />
            </div>
            <div class="wecome_lists" v-for="(item, index) in currentWecomeList" :key="item">
              <div :class="['wecome_list', index !== 0 ? 'wecome_list_line' : '']">
                <div class="wecome_list_text">{{item}}</div>
                <div class="wecome_btn" @click="onMySend(item)">问一下</div>
              </div>
            </div>
          </div>
        </div>
        <!-- 新消息列表 -->
        <div id="AILISTITEM" class="history_item" v-for="item in newList" :key="item">
          <div class="my_msg_box">
            <div class="my_msg">
              <div class="msg_text">{{item.question}}</div>
            </div>
          </div>
          <div class="ai_msg_img">
            <img
              src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-words-mini/ai/ai_title_img.png"
              alt
            />
            <div class="ai_msg_img_name">启小航</div>
          </div>
          <div class="ai_msg">
            <div class="msg_text">{{item.answer}}</div>
            <div class="stop_tip_line" v-if="item.type === 2 "></div>
            <div class="stop_tip_text" v-if="item.type === 2 ">已停止回答</div>
          </div>
        </div>

        <!-- 最新一条消息的临时展示位置 -->
        <div class="history_item" v-if="ls_my_msg || ls_ai_msg">
          <div class="my_msg_box">
            <div class="my_msg" v-if="ls_my_msg">
              <div class="msg_text">{{ls_my_msg}}</div>
            </div>
          </div>
          <div class="ai_msg_img" v-if="ls_my_msg">
            <img
              src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-words-mini/ai/ai_title_img.png"
              alt
            />
            <div class="ai_msg_img_name">启小航</div>
          </div>
          <div class="ai_msg" v-if="ls_my_msg">
            <div class="msg_text">
              {{ls_ai_msg}}
              <img
                class="msg_text_loading_box"
                src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-words-mini/ai/ai_loading.gif"
                alt
              />
            </div>
          </div>
        </div>
        <div class="empty_box"></div>
      </van-list>
      <EmptyData :emptyName="'noProductList'" v-if="listEmpty" />
      <!-- <Foot /> -->
      <!-- </van-pull-refresh> -->
    </div>
    <div class="bottom" id="ai_aisistant_bottom">
      <div class="input">
        <!-- <input
          class="userNewPsd"
          @input="onInput"
          v-model.trim="inputMsg"
          clearable
          placeholder="在这里向我提问哦~"
          @click="onFocus"
          type="text"
          @keyboardheightchange="onBoardChange"
        />-->
        <van-form>
          <van-field
            @input="onInput"
            v-model.trim="inputMsg"
            clearable
            placeholder="在这里向我提问哦~"
            @blur="onBlur"
            @click="onFocus"
            type="text"
            :disabled="sendStatus === '3' "
          />
          <!-- @focus="onFocus2" -->
        </van-form>
      </div>
      <div class="send_btn">
        <img
          class="img"
          v-if="sendStatus === '1' "
          src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-words-mini/ai/ai_no_send.png"
          alt
        />
        <img
          class="img"
          v-if="sendStatus === '2' "
          src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-words-mini/ai/ai_send.png"
          alt
          @click="onMySend(inputMsg, true)"
        />
        <img
          class="img"
          v-if="sendStatus === '3' "
          src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-words-mini/ai/ai_send_ing.png"
          alt
          @click="onStopSend"
        />
      </div>
    </div>
    <div class="ai_dis_none">
      <input type="text" ref="inputRef" />
    </div>
  </div>
</template>

<script>
import EmptyData from '@/components/emptyData/emptyData.vue';
// import Foot from '@/components/foot/privacy.vue';
// eslint-disable-next-line import/no-cycle
import {
  openAiConnect,
  stopAiConnect,
  getAiBotList,
  getAiInfo,
  getAiSessionId,
  getHistoryAiInfo,
} from '@/api/aiAssistant/index';
import moment from 'moment';
import { fetchEventSource } from '@microsoft/fetch-event-source';
import { mapState } from 'vuex';
import wx from 'weixin-js-sdk';

let canKeyBoard = false;
let canKeyBoardTime = false;

let lsTimer = null;

export default {
  components: {
    EmptyData,
    // Foot,
  },
  data() {
    return {
      historyList: [],
      newList: [], // 新回话数组
      // 优化性能，临时存储当前问题和当前回答。完成后塞入新回话数组
      ls_my_msg: '',
      ls_ai_msg: '',
      // 加载相关
      refreshing: false,
      loading: false,
      finished: false,
      // 输入框数据
      inputMsg: '',
      sendStatus: '1', // 1、不可发送  2、可发送  3、生成中
      toolDesc: '',
      toolHello: '',
      currentWecomeList: [],
      allWecomeList: [],

      showWecome: false,

      currentTime: '',

      pageNum: 1,
      pageSize: 10,

      textCallStr: '',
      textCallStrCache: '',
      textCallAi: false,

      // 当前应用id
      currAiBotID: null,
      // 当前会话id
      currSessionId: null,
      // 当前连接id
      currConnectId: null,
      stopCall: false,
    };
  },
  computed: {
    ...mapState(['userInfo']),
  },
  mounted() {
    // if (!this.userInfo?.id) {
    //   const param = { redirect: '/aiAssistant', ...this.$route.query };
    //   this.$router.push({ path: '/registrationLogin', query: param });
    //   return;
    // }
    document.getElementsByClassName('van-field__control')[0].addEventListener('click', () => {
      if (this.sendStatus !== 3) {
        this.onFocus2();
      }
    });

    window.addEventListener('scroll', this.handle);

    const { aiCode } = this.$route.query;
    console.log(aiCode, 'aiCode');
    window.scroll(0, 999999999999);
    if (!window.localStorage.getItem('AI_ASSISTANT_WECOME')) {
      this.showWecome = true;
    }
    window.localStorage.setItem('AI_ASSISTANT_WECOME', 'true');

    this.loading = true;

    let currentEnv = '';
    ['pre.iqihang', 'release.iqihang', 'test.iqihang', 'dev.iqihang'].forEach(item => {
      if (window.location.href.indexOf(item) !== -1) {
        currentEnv = item.split('.').shift();
      }
    });

    const sseUrlMap = {
      dev: 'https://sse-dev.iqihang.com/v1/ai-sse/connect',
      test: 'https://sse-test.iqihang.com/v1/ai-sse/connect',
      pre: 'https://sse-pre.iqihang.com/v1/ai-sse/connect',
    };

    this.sseUrl = sseUrlMap[currentEnv] || 'https://sse-prod.iqihang.com/v1/ai-sse/connect';

    getAiBotList().then(res => {
      console.log('应用列表', res);
      const { data, currentTime } = res;
      this.currentTime = currentTime;
      const currAIBot = data?.find(item => item.code === aiCode);
      const { guideText, recommendPrompts, name, guideTitle, id } = currAIBot || {};
      document.title = name;
      this.titleName = name;
      window.addEventListener('pageshow', () => {
        console.log('pageshow', name, this?.titleName);
        document.title = name || this?.titleName;
      });

      document.addEventListener(
        'visibilitychange',
        () => {
          console.log('visibilitychange', name, this?.titleName);
          document.title = name || this?.titleName;
          setTimeout(() => {
            document.title = name || this?.titleName;
          }, 300);
          setTimeout(() => {
            document.title = name || this?.titleName;
          }, 700);
          setTimeout(() => {
            document.title = name || this?.titleName;
          }, 1100);
        },
        false,
      );

      const recommendPromptsList = recommendPrompts ? JSON.parse(recommendPrompts) : [];
      this.toolDesc = guideText;
      this.toolHello = guideTitle;
      this.allWecomeList = recommendPromptsList;
      // this.currentWecomeList = recommendPromptsList.slice(0, 3); toolRandomWeCome
      this.currentWecomeList = this.toolRandomWeCome(recommendPromptsList);
      this.currAiBotID = id;
      getAiSessionId(id).then(res2 => {
        this.currSessionId = res2?.data;
        getHistoryAiInfo(res2?.data, this.pageNum, this.pageSize).then(res => {
          console.log(res);
          if (!res.data.data || res.data.data.length === 0) {
            this.finished = true;
          }
          this.historyList = res.data?.data?.reverse() || [];
          this.pageNum = 2;
          const afterItem = res.data?.data?.findLast(item => item.roleType === 1);
          console.log(afterItem, !afterItem, 'eee');
          if (!afterItem) {
            this.showWecome = true;
            this.toolScrollUnder();
            return;
          }
          console.log(
            '时间差',
            res.currentTime,
            afterItem.createTime,
            moment(res.currentTime).diff(moment(afterItem.createTime), 'minutes'),
          );
          if (moment(res.currentTime).diff(moment(afterItem.createTime), 'minutes') > 60) {
            this.showWecome = true;
          }
          this.toolScrollUnder();
          this.loading = false;
        });
      });
    });
  },
  methods: {
    onBoardChange(e) {
      console.log('键盘高度', e);
    },
    onLoad() {
      console.log('触发到底了');
      this.loading = true;
      if (!this.finished) {
        getHistoryAiInfo(this.currSessionId, this.pageNum, this.pageSize).then(res => {
          console.log(res);
          const list = res.data.data?.reverse();
          if (list.length > 0) {
            this.pageNum += 1;
            console.log(list);
            this.historyList = [...list, ...this.historyList];
            this.$nextTick(() => {
              const currTop = document.getElementsByClassName('history_item')[list.length]
                .offsetTop;
              window.scroll(0, currTop);
              this.loading = false;
            });
          } else {
            this.loading = false;
            this.finished = true;
          }
        });
      }

      // setTimeout(() => {
      //   const length = 4;
      //   const currTop = document.getElementsByClassName('history_item')[length - 1].offsetTop;
      //   const pushList = [Math.random(), Math.random(), Math.random(), Math.random()];
      //   console.log(pushList);
      //   this.historyList = [...pushList, ...this.historyList];
      //   this.$nextTick(() => {
      //     window.scroll(0, currTop);
      //     this.loading = false;
      //   });
      // }, 1000);
    },
    onRefresh() {
      console.log('触发刷新');
    },
    onInput() {
      console.log('input', this.inputMsg);
      if (this.inputMsg) {
        if (this.sendStatus === '1') {
          this.sendStatus = '2';
        }
      } else if (this.sendStatus === '2') {
        this.sendStatus = '1';
      }
    },
    onFocus() {
      setTimeout(() => {
        this.toolScrollUnder();
      }, 200);
    },
    onBlur() {
      canKeyBoard = false;
      if (canKeyBoardTime) {
        clearTimeout(canKeyBoardTime);
        canKeyBoardTime = null;
      }
      // window.removeEventListener('scroll', this.handle);
    },
    handle() {
      console.log('执行了', canKeyBoard);
      if (canKeyBoard) {
        canKeyBoard = false;
        this.$refs.inputRef.focus();
        this.$refs.inputRef.blur();
      }
    },
    onFocus2() {
      if (canKeyBoardTime) {
        clearTimeout(canKeyBoardTime);
        canKeyBoardTime = null;
      }
      canKeyBoardTime = setTimeout(() => {
        canKeyBoard = true;
      }, 300);
    },
    onMySend(msg, isInput) {
      if (this.sendStatus === '3') {
        return;
      }
      console.log(msg);
      this.ls_my_msg = msg;
      this.ls_ai_msg = '启小航正在思考中';
      this.textCallAi = true;
      if (isInput) {
        this.inputMsg = '';
      }
      this.sendStatus = '3';
      this.toolScrollUnder();
      // 执行获取接口
      this.eventReq(msg);
      // setTimeout(() => {
      //   this.ls_ai_msg = '';
      //   this.textCallStr = `${this.textCallStr}你猜猜我今晚吃什么你猜猜我今晚吃什么你猜猜我今晚吃什么`;
      //   this.toolScrollUnder();
      //   setTimeout(() => {
      //     console.log('1', this.textCallStr, this.textCallAi);
      //     // this.ls_ai_msg = `${this.ls_ai_msg}吃好吃的`;
      //     if (this.textCallAi) {
      //       this.textCallStr = `${this.textCallStr}吃好吃的`;
      //       this.textCallAi = false;
      //       this.toolScrollUnder();
      //     }
      //   }, 1000);
      // }, 1000);
    },
    onStopSend() {
      if (this.currConnectId) {
        this.sendStatus = '1';
        this.textCallStr = '';
        this.textCallStrCache = '';
        this.textCallAi = false;
        if (!this.textCallStr && !this.textCallStrCache) {
          this.$nextTick(() => {
            this.onPushNew(2);
          });
        }
        this.stopCall.abort();
        stopAiConnect(this.currConnectId).then(() => {});
      }
    },

    // sse请求
    eventReq(ques) {
      // const eventSource = new EventSource(
      //   `https://mobile-dev.iqihang.com/api/ark/tool/v1/ai-sse/connect?appId=${1}&content=haha&sessionId=2`,
      //   {
      //     withCredentials: true,
      //   },
      // );
      // eventSource.onmessage(msg => {
      //   console.log('响应', msg);
      // });
      const that = this;
      const token = window.localStorage.getItem('accessToken');
      const stop = new AbortController();
      this.stopCall = stop;
      fetchEventSource(this.sseUrl, {
        method: 'POST',
        body: JSON.stringify({
          appId: this.currAiBotID,
          content: ques,
          sessionId: this.currSessionId,
        }),
        signal: stop.signal,
        openWhenHidden: true,
        headers: {
          Authorization: `Bearer ${token}`,
          'content-type': 'application/json',
          // accept: '*/*',
        },
        onopen() {
          that.ls_ai_msg = '';
          console.log('开始了', this);
          return Promise.resolve();
        },
        onmessage(msg) {
          console.log('回调', msg);
          const { data } = msg;
          const { connectId, content, type } = JSON.parse(data);
          that.currConnectId = connectId;
          if (that.textCallAi && type === 2000) {
            // that.textCallStr = `${that.textCallStr}${content}`;
            if (that.textCallStr) {
              that.textCallStrCache = `${that.textCallStrCache}${that.toolFilterSymbol(content)}`;
            } else {
              that.textCallStr = that.toolFilterSymbol(content);
              that.$nextTick(() => {
                that.toolRowTextDy().call(that);
              });
            }
            that.toolScrollUnder();
          }
          if (type === 2001) {
            that.textCallAi = false;
            if (!that.textCallStr && !that.textCallStrCache) {
              that.$nextTick(() => {
                that.toolRowTextDy().call(that);
              });
            }
          }
        },
        onclose() {
          console.log('结束了');
          that.textCallAi = false;
          that.$nextTick(() => {
            if (!that.textCallStr && !that.textCallStrCache) {
              that.$nextTick(() => {
                that.toolRowTextDy().call(that);
              });
            }
          });
        },
        onerror(e) {
          console.log('报错了', e);
          that.stopCall.abort();
          // stopAiConnect(this.currConnectId).then(() => {});
        },
      });
    },

    onSwapHello() {
      // const allListLength = this.allWecomeList.length;
      // const currEnd = this.currentWecomeList[this.currentWecomeList.length - 1];
      // const currIndex = this.allWecomeList.indexOf(currEnd);

      // const newList = [];

      // if (currIndex !== -1) {
      //   for (let i = 1; i < 4; i += 1) {
      //     if (this.allWecomeList[(currIndex + i) % allListLength]) {
      //       newList.push(this.allWecomeList[(currIndex + i) % allListLength]);
      //     }
      //   }
      // }
      this.currentWecomeList = this.toolRandomWeCome(this.allWecomeList);
    },

    // 将临时消息推入新消息队列
    onPushNew(type = 1) {
      if (this.ls_ai_msg && this.ls_my_msg) {
        const optNewList = [...this.newList];
        optNewList.push({
          type,
          question: this.ls_my_msg,
          answer: this.ls_ai_msg,
        });
        this.ls_my_msg = '';
        this.ls_ai_msg = '';
        if (this.inputMsg) {
          this.sendStatus = '2';
        } else {
          this.sendStatus = '1';
        }
        this.newList = optNewList;
        this.toolScrollUnder();
      }
    },

    toolScrollUnder() {
      this.$nextTick(() => {
        window.scroll(0, 99999999999999);
      });
    },

    toolRawTime(msgTime, currTime = this.currentTime) {
      if (!msgTime) {
        return '';
      }

      const minutesDiff = moment(currTime).diff(moment(msgTime), 'minutes'); // 分钟差

      const minutesZuo = moment()
        .subtract(1, 'day')
        .format('YYYY-MM-DD'); // 昨天

      const isOneDay = msgTime.slice(0, 10) === currTime.slice(0, 10); // 是否同一天

      const isOneYear = msgTime.slice(0, 4) === currTime.slice(0, 4); // 是否同一年

      // const diff = moment(currTime).format('x') - moment(msgTime).format('x');
      // const time = moment.duration(diff);
      // const days = time.days(); // 天数差
      // console.log('天数差', days);

      if (!isOneYear) {
        return moment(msgTime).format('YYYY年MM月DD日 HH:mm');
      }

      if (minutesZuo === msgTime.slice(0, 10)) {
        return `昨天 ${msgTime.slice(11, -3)}`;
      }

      if (!isOneDay) {
        return moment(msgTime).format('MM月DD日 HH:mm');
      }
      if (minutesDiff > 60) {
        return msgTime.slice(11, -3);
      }
      return '';
    },

    toolRowTextDy() {
      if (this.textCallStr) {
        this.ls_ai_msg = `${this.ls_ai_msg}${this.textCallStr[0]}`;
        this.toolScrollUnder();
        let lsText = this.textCallStr.slice(1);
        if (!lsText) {
          lsText = this.textCallStrCache;
          this.textCallStrCache = '';
        }
        this.textCallStr = lsText;
        lsTimer = setTimeout(() => {
          clearTimeout(lsTimer);
          lsTimer = null;
          this.toolRowTextDy();
        }, 10);
        // if (lsText) {
        //   setTimeout(() => {
        //     this.toolRowTextDy();
        //   }, 100);
        // } else if (!this.textCallAi) {
        //   this.$nextTick(() => {
        //     this.onPushNew(1);
        //   });
        // }
      } else if (!this.textCallAi) {
        this.$nextTick(() => {
          this.onPushNew(1);
        });
      }
    },

    toolRandomWeCome(list) {
      const length = list?.length || 0;

      if (!list || length === 0) {
        return [];
      }
      if (length < 3) {
        return list;
      }

      const newList = [];
      const lsIdx = Math.min(Math.floor(Math.random() * length), length - 1);
      newList.push(list[lsIdx % length]);
      newList.push(list[(lsIdx + 1) % length]);
      newList.push(list[(lsIdx + 2) % length]);
      console.log(lsIdx, newList, '哈哈哈');

      return newList;
    },

    toolFilterSymbol(str) {
      return str ? str.replace(/\*{2}/g, '').replace(/#{3}/g, '') : '';
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .van-pull-refresh {
  height: 100%;
  overflow: inherit;
}

::v-deep .van-list {
  overflow: hidden;
}
.ai_dis_none {
  position: fixed;
  top: 0;
  left: 0;
  width: 1px;
  height: 1px;
  overflow: hidden;
}
.ai_box {
  padding-top: 100px;
}
.ai_box_top {
  padding-top: 0;
}
.lists_area {
  // width: 678px;
  max-height: 100%;
  padding: 0 36px 0;
  background: #f7f8fc;
  //   transform: rotateZ(180deg);
  //   overflow-y: scroll;

  .history_item {
    // width: 100%;
    // height: 100px;
    margin-top: 51px;
    // background: pink;
    overflow: hidden;
    .msg_time_box {
      display: flex;
      justify-content: center;
      width: 100%;
      height: 40px;
      margin-bottom: 51px;

      .msg_time {
        height: 40px;
        padding-right: 14px;
        padding-left: 14px;
        color: #999;
        font-weight: 400;
        font-size: 22px;
        font-family: PingFangSC, PingFang SC, sans-serif;
        font-style: normal;
        line-height: 40px;
        text-align: center;
        background: #fff;
        border-radius: 7px;
      }
    }

    .my_msg_box {
      float: right;
      width: 100%;
    }

    .my_msg {
      float: right;
      margin-bottom: 51px;
      padding: 22px 29px;
      color: #fff;
      background: #ff7f41;
      border-radius: 29px 5px 29px 29px;
    }
    .my_msg_history {
      margin-bottom: 0;
    }
    .ai_msg {
      float: left;
      padding: 22px 29px;
      color: #333;
      background: #fff;
      border-radius: 5px 29px 29px 29px;
    }

    .ai_msg_img {
      float: left;
      width: 100%;
      height: 76px;
      margin-bottom: 14px;
      img {
        display: block;
        float: left;
        width: 76px;
        height: 76px;
      }
      .ai_msg_img_name {
        float: left;
        width: 300px;
        height: 76px;
        margin-left: 14px;
        color: #666;
        font-weight: 400;
        font-size: 25px;
        font-family: PingFangSC, PingFang SC, sans-serif;
        font-style: normal;
        line-height: 76px;
      }
    }
    .msg_text {
      max-width: 620px;
      font-weight: 400;
      font-size: 29px;
      font-family: PingFangSC, PingFang SC, sans-serif;
      font-style: normal;
      line-height: 51px;
      white-space: pre-wrap;
      text-align: left;
    }

    .msg_text_loading_box {
      display: inline-block;
      width: 46px;
      height: 46px;
      margin-top: -1px;
      margin-left: 4px;
      vertical-align: middle;
    }

    .msg_text_loading {
      display: inline-block;
      height: 100%;
      overflow: hidden;
      line-height: 100%;
      animation: on_msg_text_loading 2s linear 0s infinite;
    }

    .stop_tip_line {
      height: 2px;
      margin-top: 24px;
      border: 1px solid #efefef;
    }
    .stop_tip_text {
      height: 36px;
      margin-top: 20px;
      color: #999;
      font-weight: 400;
      font-size: 25px;
      font-family: PingFangSC, PingFang SC, sans-serif;
      font-style: normal;
      line-height: 36px;
      text-align: left;
    }
  }

  .wecome_item {
    position: relative;
    width: 100%;
    // height: 100px;
    margin-top: 30px;
    // padding-top: 221px;
    // background: yellowgreen;

    .wecome_back {
      width: 678px;
      // position: absolute;
      // top: 0;
      // left: 0;
      height: 290px;
      overflow: hidden;
      background: url('https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-words-mini/ai/ai_card.png')
        no-repeat;
      background-size: 100% 100%;

      .tool_hello {
        height: 40px;
        margin-top: 54px;
        margin-left: 197px;
        color: #ff5a12;
        font-weight: 600;
        font-size: 29px;
        font-family: PingFangSC, PingFang SC, sans-serif;
        font-style: normal;
        line-height: 40px;
        text-align: left;
      }

      .tool_desc {
        width: 451px;
        margin-top: 7px;
        margin-left: 197px;
        color: #333;
        font-weight: 400;
        font-size: 25px;
        font-family: PingFangSC, PingFang SC, sans-serif;
        font-style: normal;
        line-height: 36px;
        text-align: left;
      }

      // .img {
      //   height: 100%;
      //   width: 100%;
      // }
    }

    .wecome_card {
      width: 678px;
      margin-top: -69px;
      padding: 36px 29px 0;
      background: #fff;
      border-radius: 18px;

      .wecome_tip {
        width: 100%;
        height: 36px;
        margin-bottom: 18px;

        .img_wenhao {
          float: left;
          width: 22px;
          height: 22px;
          margin-top: 7px;
        }

        .tip_wen {
          float: left;
          height: 36px;
          margin-left: 7px;
          color: #999;
          font-weight: 400;
          font-size: 22px;
          font-family: PingFangSC, PingFang SC, sans-serif;
          font-style: normal;
          line-height: 36px;
          text-align: left;
        }

        .img_qiehuan {
          float: right;
          width: 29px;
          height: 29px;
          margin-top: 4px;
        }

        .tip_qiehuan {
          float: right;
          height: 36px;
          margin-left: 7px;
          color: #999;
          font-weight: 400;
          font-size: 25px;
          font-family: PingFangSC, PingFang SC, sans-serif;
          font-style: normal;
          line-height: 36px;
          text-align: left;
        }
      }

      .wecome_lists {
        // margin-top: 17px;

        .wecome_list {
          height: 100px;

          .wecome_list_text {
            float: left;
            height: 100px;
            color: #333;
            font-weight: 400;
            font-size: 29px;
            font-family: PingFangSC, PingFang SC, sans-serif;
            font-style: normal;
            line-height: 100px;
            text-align: left;
          }

          .wecome_btn {
            float: right;
            width: 116px;
            height: 43px;
            margin-top: 28.5px;
            color: #ff7f41;
            font-weight: 500;
            font-size: 22px;
            font-style: normal;
            line-height: 43px;
            text-align: center;
            background: rgba(255, 127, 65, 0.1);
            border-radius: 22px;
          }
        }

        .wecome_list_line {
          border-top: 2px solid #efefef;
        }
      }
    }
  }
  .new_item {
    width: 100%;
    height: 100px;
    margin-top: 30px;
    background: yellowgreen;
  }
  .empty_box {
    width: 100%;
    height: 260px;
    // background: white;
    background: #f7f8fc;
  }
}
.bottom {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 6;
  width: 100%;
  height: 140px;
  background: #f7f8fc;
  // background: plum;
  .input {
    float: left;
    width: 591px;
    // height: 80px;
    margin-top: 29px;
    margin-left: 36px;
    overflow: hidden;
    background: #fff;
    border: 2px solid #e8eaef;
    border-radius: 40px;
  }
  .send_btn {
    float: left;
    width: 80px;
    height: 80px;
    margin-top: 32px;
    margin-left: 7px;
    .img {
      width: 100%;
      height: 100%;
    }
  }
}
::v-deep .van-field__control {
  // color: #999;
  font-weight: 400;
  font-family: PingFangSC, PingFang SC, sans-serif;
  // font-size: 29px;
  font-style: normal;
}
@keyframes on_msg_text_loading {
  0% {
    width: 0;
  }
  100% {
    width: 20px;
  }
}
</style>
